<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uHgraG/images/Cover.jpg?1732976352887" alt="This image is the cover for the book Folsom Prison Bloody 13, True Crime"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Folsom Prison Bloody 13, True Crime
      </h1>
      <p class="bookDescription body article font2">
        <p>On July 27, 1903, spurred into action by inmate Richard 'Red' Gordon, thirteen men attacked their jailers and made a run for freedom.Folsom Prison had only been open for 20 years and was already one of the toughest and most brutal prisons in the country. It had one major flaw--no walls. A statewide manhunt ensued, following a deadly trail of attacks, kidnappings, and murder. Among the escapees were Joseph Theron and Frank Case, both sentenced to life in prison for robbery, and Joseph Murphy, burglar and poet. Sightings were reported from San Franciso to Reno and in the end, five of the prisoners were never found.Join author Josh Morgan as he recounts the violence and heroism of Folsom Prison's biggest breakout.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Josh Morgan
      </h2>
      
      <p class="authorDescription body article">Josh Morgan lives in the Sierra Nevada foothills of California with his wife and two daughters. You'll often find him running trails through the gold country and exploring Northern California, where his family has lived since the 1860s. Josh earned undergraduate and graduate degrees from the University of the Pacific and works at Sierra College.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01da0074